import {CardEnum} from '@colonist/game-states'
import CardResCardBack from '@static/images/card_rescardback.svg'
import CardLumber from '@static/images/card_lumber.svg'
import CardBrick from '@static/images/card_brick.svg'
import CardWool from '@static/images/card_wool.svg'
import CardGrain from '@static/images/card_grain.svg'
import CardOre from '@static/images/card_ore.svg'
import CardCloth from '@static/images/card_cloth.svg'
import CardCoin from '@static/images/card_coin.svg'
import CardPaper from '@static/images/card_paper.svg'
import CardDevCardBack from '@static/images/card_devcardback.svg'
import CardKnight from '@static/images/card_knight.svg'
import CardVp from '@static/images/card_vp.svg'
import CardMonopoly from '@static/images/card_monopoly.svg'
import CardRoadbuilding from '@static/images/card_roadbuilding.svg'
import CardYearOfPlenty from '@static/images/card_yearofplenty.svg'
import CardProgressTradeBack from '@static/images/card_progress_trade_back.svg'
import CardProgressTradeCommercialHarbor from '@static/images/card_progress_trade_commercial_harbor.svg'
import CardProgressTradeMasterMerchant from '@static/images/card_progress_trade_master_merchant.svg'
import CardProgressTradeMerchant from '@static/images/card_progress_trade_merchant.svg'
import CardProgressTradeMerchantFleet from '@static/images/card_progress_trade_merchant_fleet.svg'
import CardProgressTradeResourceMonopoly from '@static/images/card_progress_trade_resource_monopoly.svg'
import CardProgressTradeCommodityMonopoly from '@static/images/card_progress_trade_commodity_monopoly.svg'
import CardProgressPoliticsBack from '@static/images/card_progress_politics_back.svg'
import CardProgressPoliticsBishop from '@static/images/card_progress_politics_bishop.svg'
import CardProgressPoliticsConstitution from '@static/images/card_progress_politics_constitution.svg'
import CardProgressPoliticsDeserter from '@static/images/card_progress_politics_deserter.svg'
import CardProgressPoliticsDiplomat from '@static/images/card_progress_politics_diplomat.svg'
import CardProgressPoliticsIntrigue from '@static/images/card_progress_politics_intrigue.svg'
import CardProgressPoliticsSaboteur from '@static/images/card_progress_politics_saboteur.svg'
import CardProgressPoliticsSpy from '@static/images/card_progress_politics_spy.svg'
import CardProgressPoliticsWarlord from '@static/images/card_progress_politics_warlord.svg'
import CardProgressPoliticsWedding from '@static/images/card_progress_politics_wedding.svg'
import CardProgressScienceBack from '@static/images/card_progress_science_back.svg'
import CardProgressScienceAlchemist from '@static/images/card_progress_science_alchemist.svg'
import CardProgressScienceCrane from '@static/images/card_progress_science_crane.svg'
import CardProgressScienceEngineer from '@static/images/card_progress_science_engineer.svg'
import CardProgressScienceInventor from '@static/images/card_progress_science_inventor.svg'
import CardProgressScienceIrrigation from '@static/images/card_progress_science_irrigation.svg'
import CardProgressScienceMedicine from '@static/images/card_progress_science_medicine.svg'
import CardProgressScienceMining from '@static/images/card_progress_science_mining.svg'
import CardProgressSciencePrinter from '@static/images/card_progress_science_printer.svg'
import CardProgressScienceRoadBuilding from '@static/images/card_progress_science_road_building.svg'
import CardProgressScienceSmith from '@static/images/card_progress_science_smith.svg'
import CardProgressBack from '@static/images/card_progress_back.svg'
import {ImageURL} from '@colonist/types'

export const CARD_IMAGES: Record<CardEnum, ImageURL> = {
    [CardEnum.ResourceBack]: CardResCardBack,
    [CardEnum.Lumber]: CardLumber,
    [CardEnum.Brick]: CardBrick,
    [CardEnum.Wool]: CardWool,
    [CardEnum.Grain]: CardGrain,
    [CardEnum.Ore]: CardOre,
    [CardEnum.Cloth]: CardCloth,
    [CardEnum.Coin]: CardCoin,
    [CardEnum.Paper]: CardPaper,
    [CardEnum.AnyResource]: CardResCardBack,
    [CardEnum.DevelopmentBack]: CardDevCardBack,
    [CardEnum.Knight]: CardKnight,
    [CardEnum.VictoryPoint]: CardVp,
    [CardEnum.Monopoly]: CardMonopoly,
    [CardEnum.RoadBuilding]: CardRoadbuilding,
    [CardEnum.YearOfPlenty]: CardYearOfPlenty,
    [CardEnum.CommodityBack]: CardResCardBack,
    [CardEnum.ProgressCardTradeBack]: CardProgressTradeBack,
    [CardEnum.ProgressCardTradeCommercialHarbor]: CardProgressTradeCommercialHarbor,
    [CardEnum.ProgressCardTradeMasterMerchant]: CardProgressTradeMasterMerchant,
    [CardEnum.ProgressCardTradeMerchant]: CardProgressTradeMerchant,
    [CardEnum.ProgressCardTradeMerchantFleet]: CardProgressTradeMerchantFleet,
    [CardEnum.ProgressCardTradeResourceMonopoly]: CardProgressTradeResourceMonopoly,
    [CardEnum.ProgressCardTradeCommodityMonopoly]: CardProgressTradeCommodityMonopoly,
    [CardEnum.ProgressCardPoliticsBack]: CardProgressPoliticsBack,
    [CardEnum.ProgressCardPoliticsBishop]: CardProgressPoliticsBishop,
    [CardEnum.ProgressCardPoliticsConstitution]: CardProgressPoliticsConstitution,
    [CardEnum.ProgressCardPoliticsDeserter]: CardProgressPoliticsDeserter,
    [CardEnum.ProgressCardPoliticsDiplomat]: CardProgressPoliticsDiplomat,
    [CardEnum.ProgressCardPoliticsIntrigue]: CardProgressPoliticsIntrigue,
    [CardEnum.ProgressCardPoliticsSaboteur]: CardProgressPoliticsSaboteur,
    [CardEnum.ProgressCardPoliticsSpy]: CardProgressPoliticsSpy,
    [CardEnum.ProgressCardPoliticsWarlord]: CardProgressPoliticsWarlord,
    [CardEnum.ProgressCardPoliticsWedding]: CardProgressPoliticsWedding,
    [CardEnum.ProgressCardScienceBack]: CardProgressScienceBack,
    [CardEnum.ProgressCardScienceAlchemist]: CardProgressScienceAlchemist,
    [CardEnum.ProgressCardScienceCrane]: CardProgressScienceCrane,
    [CardEnum.ProgressCardScienceEngineer]: CardProgressScienceEngineer,
    [CardEnum.ProgressCardScienceInventor]: CardProgressScienceInventor,
    [CardEnum.ProgressCardScienceIrrigation]: CardProgressScienceIrrigation,
    [CardEnum.ProgressCardScienceMedicine]: CardProgressScienceMedicine,
    [CardEnum.ProgressCardScienceMining]: CardProgressScienceMining,
    [CardEnum.ProgressCardSciencePrinter]: CardProgressSciencePrinter,
    [CardEnum.ProgressCardScienceRoadBuilding]: CardProgressScienceRoadBuilding,
    [CardEnum.ProgressCardScienceSmith]: CardProgressScienceSmith,
    [CardEnum.ProgressCardBack]: CardProgressBack,
} as const
